__turbopack_context__.v({
  "container": "oOjYdG_container",
  "content": "oOjYdG_content",
  "footer": "oOjYdG_footer",
  "footerContent": "oOjYdG_footerContent",
  "message": "oOjYdG_message",
});
